import { Skeleton } from "antd";
import { Div, Text, Col } from "../../../styles/Common";
import { theme } from "../../../styles/theme";
import { getIdSurveyStatusCompleted, getIdSurveyStatusIncomplete, getIdSurveyStatusOpen, getSequentialCardStyles } from "../../../utilities/helpers";
import { ChevronRightIcon, DataIcon } from "../../../assets/icons";

export const SurveyCard = ({ survey, isMobile, onCardClick, status, optionsSurveyStatus }) => {
  const styles = getSequentialCardStyles(survey.categoryId);
  const completed = getIdSurveyStatusCompleted(optionsSurveyStatus);
  const incomplete = getIdSurveyStatusIncomplete(optionsSurveyStatus);
  const open = getIdSurveyStatusOpen(optionsSurveyStatus);
  const isStatus = status?.value == completed || status?.value == open || status?.value == incomplete;
  return (
    <Div
      width={!isMobile ? "32%" : "100%"}
      minHeight="120px"
      radius="24px"
      background={styles.background}
      align="left"
      p="20px 17px 20px 24px"
      onClick={onCardClick}
      style={{ 
        cursor: "pointer",
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      {/* (isStatus) && (
        <Div
          background={theme.colors.purpleBold}
          p="6px 20px" 
          radius="0 24px 0 16px" 
          style={{
            position: 'absolute',
            top: '0',
            right: '0',
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)"
          }}
        >
          <Text 
            color="white" 
            size={theme.fonts.size.sm}
            weight="bold"
          >
            {status?.label}
          </Text>
        </Div>
      ) */}
      <Col justify="center" m="0 15.5px 0 0">
        <Div
          background={styles.backgroundLight}
          width="50px"
          height="50px"
          radius="11px"
          align="center"
          justify="center"
        >
          <DataIcon
            stroke={styles.background}
            width="24px"
            height="24px"
          />
        </Div>
      </Col>
      <Col justify="center" width="100%">
        <Text color={styles.color} mb="9px"> 
          {survey.categoryName}
        </Text>
        <Text
          weight={theme.fonts.weight.bold}
          color={styles.color}
          size={theme.fonts.size.h6}
        >
          {survey.name}
        </Text>
      </Col>
      <Col justify="center">
        <ChevronRightIcon
          width="32px"
          height="32px"
          stroke={styles.color}
        />
      </Col>
    </Div>
  );
};
  
const SurveyCardSkeleton = ({ isMobile }) => {
  return (
    <Div
      width={!isMobile ? "32%" : "100%"}
      minHeight="120px"
      radius="24px"
      background={theme.colors.blue50}
      align="left"
      p="30px 17px 30px 24px"
      style={{ 
        position: 'relative',
        overflow: 'hidden',
        alignItems: 'center'
      }}
    >
      <Col style={{ width: '80%' }}>
        <Skeleton.Input 
          active 
          size="small" 
          style={{ 
            width: '60%', 
            height: '16px',
            marginBottom: '5px' 
          }} 
        />
        <Skeleton.Input 
          active 
          size="small" 
          style={{ 
            width: '90%', 
            height: '24px' 
          }} 
        />
      </Col>
      <Col justify="center">
        <Skeleton.Avatar 
          active 
          size="large" 
          style={{ 
            width: '32px', 
            height: '32px',
            borderRadius: '50%' 
          }} 
        />
      </Col>
    </Div>
  );
};
  
export const SurveysSkeleton = ({ count = 3, isMobile }) => {
  return (
    <>
      {Array(count).fill().map((_, index) => (
        <SurveyCardSkeleton key={index} isMobile={isMobile} />
      ))}
    </>
  );
};